const constants = {
  MAP_CENTER_KEY: 'map_center',
  MAP_ZOOM_KEY: 'map_zoom',
  TRACKER_MARKER_IMAGE_ID: 'tracker',
  EVENT_MARKER_IMAGE_ID: 'event',
  VR_MARKER_IMAGE_ID: 'camera',
  ANTEA_MARKER_IMAGE_ID: 'sensor',
  NAV_ACTIVE_TAB: 'nav_active_tab',
  MAP_LAYER_PARKING_ID: 'parking',
  MAP_LAYER_EVENT_ID: 'events',
  MAP_LAYER_TREES_ID: 'trees',
  MAP_LAYER_TRAVEL_ID: 'travel',
  MAP_LAYER_TRAFFIC_ID: 'traffic',
  MAP_LAYER_ANTEA_ID: 'antea',
  MAP_LAYER_VR_ID: 'vr',
  MAP_LAYER_WEATHER_ID: 'weer',
  MAP_LAYER_SURVEY_ID: 'experience-sampling',
  MAP_LAYER_TRACKERS_ID: 'trackers',
  MAP_LAYER_TRACKERS_HEATMAP_ID: 'trackers-heatmap',
  MAP_LAYER_TRACKERS_ROUTES_ID: 'trackerroutes',
  MAP_LAYER_TRACKERS_LIKES: 'trackerslikes',
  CONTEXT_TITLE_MAPPING: {
    'events': 'Evenementen',
    'traffic': 'Drukte kruispunten',
    'parking': 'Parkeren',
    'antea': 'Antea metingen',
    'vr': 'VR-enquête',
    'trackers': 'GPS trackers',
    'experience-sampling': 'Experiencesampling'
  },
  TRAVELTIME_SHAPES_MAPPING: {
    'urn:ngsi-ld:TravelTimeType:RSD01_DEV_N344_00_Re': [423347136, 422347067, 422347098, 421347134, 421347130, 420347044, 419348078, 419348081, 418348073, 418348089, 418348090, 417348084, 417348075, 416348075],
    'urn:ngsi-ld:TravelTimeType:RSD01_DEV_HOW_02_re': [415349021, 415348148, 415348149, 415348067, 415348174, 416348076],
    'urn:ngsi-ld:TravelTimeType:RSD01_DEV_HOW_02_LI': [41534902110101, 41534814810101, 41534814910101, 41534806710101, 41534817410101, 41634807610101],
    'urn:ngsi-ld:TravelTimeType:RSD01_DEV-STA-1-RE': [414349069, 415349080, 415349085, 415349086, 415349089],
    'urn:ngsi-ld:TravelTimeType:RSD01_DEV-STA-1-LI':[41534908010101, 41434906910101, 415349079, 415349084, 415349083],
    'urn:ngsi-ld:TravelTimeType:RSD01_DEV-BGW-4-LI': [416349146, 416349140, 416349094, 416349005, 416349004, 416349095, 416349097, 416349142],
    'urn:ngsi-ld:TravelTimeType:RSD01_DEV-OSS-1-RE': [413348005, 413349043, 413349068, 413349069],
    'urn:ngsi-ld:TravelTimeType:RSD01_DEV-SIN-1-RE': [414349091, 414349090, 414349011, 414349012, 414349059, 414349063, 415349019, 415349020],
    'urn:ngsi-ld:TravelTimeType:RSD01_DEC-SIN-1-LI': [41434909110101, 41434909010101, 41434901110101, 41434901210101, 41434905910101, 41434906310101, 41534901910101, 41534902010101],
    'urn:ngsi-ld:TravelTimeType:RSD01_DEV_MRB_02_LI': [414347044, 414346032, 413346054],
    'urn:ngsi-ld:TravelTimeType:RSD01_DEV-MRB_03_li': [416347132, 416347135,416348101, 416348102, 416348104, 416348105],
    'urn:ngsi-ld:TravelTimeType:RSD01_DEV_MRB_01_re': [416347071, 416347073,416348097,416348103,416348015, 416348078],
    'urn:ngsi-ld:TravelTimeType:RSD01_DEV_MRB_01_LI': [416347114, 416347077, 416347078, 416347111, 416346062, 416346063, 416346039, 416346024, 416346028, 416346067, 417346014, 417345075, 416348077],
    'urn:ngsi-ld:TravelTimeType:RSD01_DEV_HOW_05_re': [416348113, 416348112, 417348085, 417348083],
    'urn:ngsi-ld:TravelTimeType:RSD01_DEV-CTB-1-RE': [413351033, 413351031, 414351046, 414351042, 414351044, 414351047, 415351079, 415351080, 415350091, 415350093, 415350131],
    'urn:ngsi-ld:TravelTimeType:RSD01_DEV-HHS-1-RE': [415350072, 416350023, 416351061, 416350022, 416351080],
    'urn:ngsi-ld:TravelTimeType:RSD01_DEV-CTB-2-RE': [416350051, 416350050, 416350049, 416350047, 415350130],
    'urn:ngsi-ld:TravelTimeType:RSD01_DEV-CTB-2-LI': [ 415350067, 416350052, 416350054, 416350055, 416350090, 416350089],
    'urn:ngsi-ld:TravelTimeType:RSD01_DEV_ZUW_05_li': [417350030, 417349094, 418349073, 418349072],
  }
}

export default constants
